'use strict';
import {DOM} from "./DOM.js";

export class Ajax {
	#admin_ajax;
	constructor() {
		this.#admin_ajax = admin_ajax[0];
	}

	handlers() {
		this.changeElementStatus('.select_reporting_detailed_action', 'toggle_donation_visibility');
		this.changeElementStatus('.select_reporting_detailed_action', 'change_order_status');
		this.changeElementStatus('.select_reporting_recurrence_action', 'change_subscription_status', true);
		this.changeElementStatus('.select_fundraising_campaign_donors_action','toggle_donation_visibility', true);
		this.changeElementStatus('.select_fundraising_campaign_donors_action','change_order_status', true);
		this.changeElementStatus('.select_p2p_campaign_donors_action','toggle_donation_visibility', true);
		this.changeElementStatus('.select_p2p_campaign_donors_action','change_order_status', true);
		this.changeElementStatus('.select_p2p_campaign_action','change_p2p_campaign_status', true);
		this.changeElementStatus('.select_email_action','change_email_status');
		this.changeElementStatus('.select_email_action','delete_levcharity_email', true);
		this.changeElementStatus('.select_confirmation_action','change_confirmation_status');
		this.changeElementStatus('.select_confirmation_action','delete_levcharity_confirmation', true);
		this.changeElementStatus('.select_offline_action','change_order_status', true);
		this.changeElementStatus('.select_participants_action','change_team_member_and_participant_campaign_status', true);
		this.changeElementStatus('.select_team_members_action','change_team_member_and_participant_campaign_status', true);
		this.changeElementStatus('.select_member_of_the_team_action','levcharity_user_approval_to_team', true);
		this.changeElementStatus('.select_ecard_action','change_ecard_status', true);
		this.changeElementStatus('.select_salesforce_warning_log_action', 'change_salesforce_warning_status');
		this.changeElementStatus('.select_salesforce_error_log_action', 'change_salesforce_error_status');
		this.changeElementStatus('.select_membership_action', 'change_membership_status');
		this.changeElementStatus('.select_form_product_order_action', 'change_order_status', true);
		this.changeElementStatus('.duplicate_record', 'levcharity_duplicate_record', true);
		this.sendEmailNotification('.select_offline_action', 'send_email_action', true);
		this.triggerAction('.select_participants_action', 'open_commitments_modal');
	}



	sendEmailNotification(elementClass, action, confirmation = false, type = 'change') {
		document.addEventListener(type, (event) => {
			if (event.target.matches(elementClass)) {
				const xhr = new XMLHttpRequest();

				const url = this.#admin_ajax;
				const id = event.target.selectedOptions[0].dataset.id;

				const value = event.target.value;
				const nonce = event.target.selectedOptions[0].dataset.token;
				let proceed = false;
				let confirmMessage = '';

				if ('send-email' === value) {
					proceed = true;
					const params = new URLSearchParams();
					params.append('action', action);
					params.append('id', id);
					params.append('nonce', nonce);
					xhr.open('POST', url, true);
					xhr.setRequestHeader(
						'Content-type',
						'application/x-www-form-urlencoded'
					);
					xhr.onreadystatechange = () => {
						if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
							alert('Email sent successfully');
						}
					};
					xhr.send(params);
				}
			}
		});
	}


	changeElementStatus(elementClass, action, confirmation = false, type = 'change') {
		document.addEventListener(type, ( event ) => {
			if ( event.target.matches(elementClass)) {
				const url = this.#admin_ajax;
				const id = event.target.selectedOptions[0].dataset.id;
				const title = event.target.selectedOptions[0].dataset.title ?? '';
				const teamId = event.target.selectedOptions[0].dataset.teamid ?? '';
				const captainId = event.target.selectedOptions[0].dataset.captainid ?? '';
				const value = event.target.value;
				const nonce = event.target.selectedOptions[0].dataset.token;
				let proceed = false;
				let confirmMessage = '';

				const params = new URLSearchParams();
				params.append('action', action);
				if(action === 'toggle_donation_visibility' && value === 'cancel-order') return;
				if(action === 'levcharity_duplicate_record' && (value === 'approve-campaign' || value === 'disapprove-campaign')) return;

				if(action === 'levcharity_duplicate_record' && value !== 'duplicate') return;

				if (id) {
					params.append('id', id);
				}

				if (nonce) {
					params.append('nonce', nonce);
				}

				if ('cancel-order' === value) {
					proceed = true;
					params.append('status', 'cancelled');
					// translators: %s will be replaced by order id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to cancel the order %s. Are you sure?', 'levcharity'), id);
				}

				if ('complete-order' === value) {
					proceed = true;
					params.append('status', 'completed');
					// translators: %s will be replaced by order id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change the status of the order %s to completed. Are you sure?', 'levcharity'), id);
				}

				if ('approve-order' === value) {
					proceed = true;
					params.append('status', 'pending');
					// translators: %s will be replaced by order id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change the status of the order %s to pending. Are you sure?', 'levcharity'), id);
				}

				if ('disapprove-order' === value) {
					proceed = true;
					params.append('status', 'disapproved');
					// translators: %s will be replaced by order id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change the status of the order %s to disapproved. Are you sure?', 'levcharity'), id);
				}

				if ('activate-subscription' === value) {
					proceed = true;
					params.append('status', 'active');
					// translators: %s will be replaced by subscription id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to activate the subscription %s. Are you sure?', 'levcharity'), id);
				}

				if ('pause-subscription' === value) {
					proceed = true;
					params.append('status', 'on-hold');
					// translators: %s will be replaced by subscription id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to pause the subscription %s. Are you sure?', 'levcharity'), id);
				}

				if ('cancel-subscription' === value) {
					proceed = true;
					params.append('status', 'cancelled');
					// translators: %s will be replaced by subscription id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to cancel the subscription %s. Are you sure?', 'levcharity'), id);
				}

				if ('hide-donor-name' === value && 'toggle_donation_visibility' === action) {
					proceed = true;
					params.append('action_name', value);
					params.append('status', 'on');
					// translators: %s will be replaced with the order id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to hide donor\'s name for order ID %s. Are you sure?', 'levcharity'), id);
				}

				if ('show-donor-name' === value && 'toggle_donation_visibility' === action) {
					proceed = true;
					params.append('action_name', value);
					params.append('status', '');
					// translators: %s will be replaced with the order id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to show donor\'s name for order ID %s. Are you sure?', 'levcharity'), id);
				}

				if ('hide-donation-amount' === value && 'toggle_donation_visibility' === action) {
					proceed = true;
					params.append('action_name', value);
					params.append('status', 'on');
					// translators: %s will be replaced with the order id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to hide donor\'s amount for order ID %s. Are you sure?', 'levcharity'), id);
				}

				if ('show-donation-amount' === value && 'toggle_donation_visibility' === action) {
					proceed = true;
					params.append('action_name', value);
					params.append('status', '');
					// translators: %s will be replaced with the order id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to show donor\'s amount for order ID %s. Are you sure?', 'levcharity'), id);
				}

				if ('approve-campaign' === value) {
					proceed = true;
					params.append('status', 'publish');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to approve %s. Are you sure?', 'levcharity'), title);
				}

				if ('disapprove-campaign' === value) {
					proceed = true;
					params.append('status', 'pending');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to disapprove %s. Are you sure?', 'levcharity'), title);
				}

				if ('publish-ecard' === value || 'publish-membership' === value) {
					proceed = true;
					params.append('status', 'publish');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to publish %s. Are you sure?', 'levcharity'), title);
				}

				if ('draft-ecard' === value || 'draft-membership' === value) {
					proceed = true;
					params.append('status', 'draft');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change status of %s to draft. Are you sure?', 'levcharity'), title);
				}

				if ('activate-email' === value && 'change_email_status' === action) {
					proceed = true;
					params.append('status', '1');
				}

				if ('deactivate-email' === value && 'change_email_status' === action) {
					proceed = true;
					params.append('status', '0');
				}

				if ('delete-email' === value && 'delete_levcharity_email' === action) {
					proceed = true;
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to delete email "%s". Are you sure?', 'levcharity'), title)
				}

				if ('activate-confirmation' === value && 'change_confirmation_status' === action) {
					proceed = true;
					params.append('status', '1');
				}

				if ('deactivate-confirmation' === value && 'change_confirmation_status' === action) {
					proceed = true;
					params.append('status', '0');
				}

				if ('delete-confirmation' === value && 'delete_levcharity_confirmation' === action) {
					proceed = true;
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to delete confirmation "%s". Are you sure?', 'levcharity'), title);
				}

				if ('approve-participant' === value || 'approve-member' === value) {
					proceed = true;
					params.append('status', 'publish');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change status of "%s" to approved. Are you sure?', 'levcharity'), title);
				}

				if ('cancel-participant' === value || 'cancel-member' === value) {
					proceed = true;
					params.append('status', 'cancelled');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change status of "%s" to disapproved. Are you sure?', 'levcharity-teams'), title);
				}

				if ('approve-team-member' === value) {
					proceed = true;
					params.append('action_name', value);
					params.append('user_id', id);
					params.append('team_id', teamId);
					params.append('captain_id', captainId);
					params.append('status', 'approved');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change status of "%s" to approved. Are you sure?', 'levcharity'), title);
				}

				if ('cancel-team-member' === value) {
					proceed = true;
					params.append('action_name', value);
					params.append('user_id', id);
					params.append('team_id', teamId);
					params.append('captain_id', captainId);
					params.append('status', 'cancelled');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change status of "%s" to disapproved. Are you sure?', 'levcharity-teams'), title);
				}

				if ('processing-warning' === value) {
					proceed = true;
					params.append('status', 'processing');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change warning status to processing for Salesforce ID %s. Are you sure?', 'levcharity'), title);
				}

				if ('complete-warning' === value) {
					proceed = true;
					params.append('status', 'completed');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change warning status to completed for Salesforce ID %s. Are you sure?', 'levcharity'), title);
				}

				if ('process-again' === value) {
					proceed = true;
					params.append('status', 'new');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change error status to new for ID %s. Are you sure?', 'levcharity'), title);
				}

				if ('duplicate' === value && 'levcharity_duplicate_record' === action) {
					proceed = true;
					params.append('duplicate', true);
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to duplicate. Are you sure?', 'levcharity'), title);
				}

				if (proceed === false) {
					return;
				}

				if (confirmation === true && confirmMessage) {
					if (!confirm(confirmMessage)){
						event.target.value = '';
						return;
					}
				}

				const queryString = params.toString();

				document.body.classList.add('has-overlay');
				const xhr = new XMLHttpRequest();
				xhr.open('POST', url, true);
				xhr.setRequestHeader(
					'Content-type',
					'application/x-www-form-urlencoded'
				);

				xhr.onreadystatechange = () => {
					if (
						xhr.readyState === XMLHttpRequest.DONE &&
						xhr.status === 200
					) {
						const closestRow = event.target.closest('tr');
						let statusSpan = closestRow?.querySelector('.levcharity_datatable_action_status');
						if (!statusSpan && closestRow.hasAttribute('data-dt-row')) {
							const parentRow = closestRow?.previousElementSibling;
							if (parentRow?.classList.contains('dt-hasChild')) {
								statusSpan = parentRow.querySelector('.levcharity_datatable_action_status');
							}
						}

						let response = ''

						try {
							response = JSON.parse(xhr.response)
						} catch (e) {
							response = xhr.response;
						}

						if (response?.message) {
							alert(response.message);
						}

						const elementId = elementClass.replace(".", "#") + '_' + id;

						if ('complete-order' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('wc-processing', 'wc-pending', 'wc-completed');
								statusSpan.classList.add('wc-completed');
								statusSpan.innerText = wp.i18n.__('Completed', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="cancel-order"]`)?.removeAttribute('disabled');
						}

						if ('cancel-order' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('wc-processing', 'wc-pending', 'wc-completed');
								statusSpan.classList.add('wc-cancelled');
								statusSpan.innerText = wp.i18n.__('Cancelled', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="complete-order"]`)?.removeAttribute('disabled');
						}

						if ('approve-order' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('wc-awaiting-approval', 'wc-disapproved');
								statusSpan.classList.add('wc-pending');
								statusSpan.innerText = wp.i18n.__('Pending', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="approve-order"]`)?.setAttribute('disabled', 'disabled');
						}

						if ('disapprove-order' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('wc-awaiting-approval', 'wc-pending');
								statusSpan.classList.add('wc-disapproved');
								statusSpan.innerText = wp.i18n.__('Disapproved', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="disapprove-order"]`)?.setAttribute('disabled', 'disabled');
						}

						if ('activate-subscription' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('wc-on-hold', 'wc-cancelled');
								statusSpan.classList.add('wc-active');
								statusSpan.innerText = wp.i18n.__('Active', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="pause-subscription"]`)?.removeAttribute('disabled');
							document.querySelector(`${elementId} option[value="cancel-subscription"]`)?.removeAttribute('disabled');
						}

						if ('pause-subscription' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('wc-active', 'wc-cancelled');
								statusSpan.classList.add('wc-on-hold');
								statusSpan.innerText = wp.i18n.__('On Hold', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="activate-subscription"]`)?.removeAttribute('disabled');
							document.querySelector(`${elementId} option[value="cancel-subscription"]`)?.removeAttribute('disabled');
						}

						if ('cancel-subscription' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('wc-active', 'wc-on-hold');
								statusSpan.classList.add('wc-cancelled');
								statusSpan.innerText = wp.i18n.__('Cancelled', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="activate-subscription"]`)?.removeAttribute('disabled');
							document.querySelector(`${elementId} option[value="pause-subscription"]`)?.removeAttribute('disabled');
						}

						if ('hide-donor-name' === value) {
							document.querySelector(`${elementId} option[value="show-donor-name"]`)?.removeAttribute('disabled');
						}

						if ('show-donor-name' === value) {
							document.querySelector(`${elementId} option[value="hide-donor-name"]`)?.removeAttribute('disabled');
						}

						if ('hide-donation-amount' === value) {
							document.querySelector(`${elementId} option[value="show-donation-amount"]`)?.removeAttribute('disabled');
						}

						if ('show-donation-amount' === value) {
							document.querySelector(`${elementId} option[value="hide-donation-amount"]`)?.removeAttribute('disabled');
						}

						if ('approve-campaign' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('pending');
								statusSpan.classList.add('publish');
								statusSpan.innerText = wp.i18n.__('Publish', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="disapprove-campaign"]`)?.removeAttribute('disabled');
						}

						if ('disapprove-campaign' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('publish');
								statusSpan.classList.add('pending');
								statusSpan.innerText = wp.i18n.__('Pending', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="approve-campaign"]`)?.removeAttribute('disabled');
						}

						if ('publish-ecard' === value || 'publish-membership' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('draft');
								statusSpan.classList.add('publish');
								statusSpan.innerText = wp.i18n.__('Publish', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="draft-ecard"]`)?.removeAttribute('disabled');
						}

						if ('draft-ecard' === value || 'draft-membership' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('publish');
								statusSpan.classList.add('draft');
								statusSpan.innerText = wp.i18n.__('Draft', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="publish-ecard"]`)?.removeAttribute('disabled');
						}

						if ('activate-email' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('status-inactive');
								statusSpan.classList.add('status-active');
								statusSpan.innerText = wp.i18n.__('Active', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="deactivate-email"]`)?.removeAttribute('disabled');
						}

						if ('deactivate-email' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('status-active');
								statusSpan.classList.add('status-inactive');
								statusSpan.innerText = wp.i18n.__('Inactive', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="activate-email"]`)?.removeAttribute('disabled');
						}

						if ('delete-email' === value || 'delete-confirmation' === value) {
							closestRow?.remove();
						}

						if ('activate-confirmation' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('status-inactive');
								statusSpan.classList.add('status-active');
								statusSpan.innerText = wp.i18n.__('Active', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="deactivate-confirmation"]`)?.removeAttribute('disabled');
						}

						if ('deactivate-confirmation' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('status-active');
								statusSpan.classList.add('status-inactive');
								statusSpan.innerText = wp.i18n.__('Inactive', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="activate-confirmation"]`)?.removeAttribute('disabled');
						}

						if ('approve-participant' === value || 'approve-member' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('pending', 'disapproved');
								statusSpan.classList.add('publish');
								statusSpan.innerText = wp.i18n.__('Publish', 'levcharity');
							}
						}

						if ('approve-participant' === value) {
							document.querySelector(`${elementId} option[value="cancel-participant"]`)?.removeAttribute('disabled');
						}

						if ('approve-member' === value) {
							document.querySelector(`${elementId} option[value="cancel-member"]`)?.removeAttribute('disabled');
						}

						if ('cancel-participant' === value || 'cancel-member' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('pending', 'publish');
								statusSpan.classList.add('disapproved');
								statusSpan.innerText = wp.i18n.__('Disapproved', 'levcharity');
							}
						}

						if ('cancel-participant' === value) {
							document.querySelector(`${elementId} option[value="approve-participant"]`)?.removeAttribute('disabled');
						}

						if ('cancel-member' === value) {
							document.querySelector(`${elementId} option[value="approve-member"]`)?.removeAttribute('disabled');
						}

						if ('approve-team-member' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('pending', 'disapproved');
								statusSpan.classList.add('approved');
								statusSpan.innerText = wp.i18n.__('Approved', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="cancel-team-member"]`)?.removeAttribute('disabled');
						}

						if ('cancel-team-member' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('pending', 'approved');
								statusSpan.classList.add('disapproved');
								statusSpan.innerText = wp.i18n.__('Disapproved', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="approve-team-member"]`)?.removeAttribute('disabled');
						}

						if ('processing-warning' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('new', 'completed');
								statusSpan.classList.add('processing');
								statusSpan.innerText = wp.i18n.__('Processing', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="complete-warning"]`)?.removeAttribute('disabled');
						}

						if ('complete-warning' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('new', 'processing');
								statusSpan.classList.add('completed');
								statusSpan.innerText = wp.i18n.__('Completed', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="processing"]`)?.removeAttribute('disabled');
						}

						if ('process-again' === value) {
							if (statusSpan) {
								statusSpan.classList.remove('error');
								statusSpan.classList.add('new');
								statusSpan.innerText = wp.i18n.__('New', 'levcharity');
							}
							document.querySelector(`${elementId} option[value="process-again"]`)?.removeAttribute('disabled');
						}

						event.target.selectedOptions[0].setAttribute('disabled', 'disabled');
						event.target.value = '';

						if (response?.reload) {
							window.location.reload();
						}

					} else if ( xhr.readyState === XMLHttpRequest.DONE ) {
						let response = ''

						try {
							response = JSON.parse(xhr.response)
						} catch (e) {
							response = xhr.response;
						}

						if (response?.message) {
							alert(response.message)
						} else {
							alert(response)
						}
					}
					document.body.classList.remove('has-overlay');
				};

				xhr.send(queryString);
			}
		});
	}

	triggerAction(elementClass, action, type = 'change') {
		document.addEventListener(type, async ( event ) => {
			if ( event.target.matches(elementClass)) {
				const value = event.target.value;
				const token = event.target.selectedOptions[0].dataset.token;
				const id = event.target.selectedOptions[0].dataset.id;

				if (action === 'open_commitments_modal' && value === 'commitments-modal') {
					const {Components} = await import('./Components.js' /* webpackChunkName: "components" */);

					const contentHTML = `<div class="levcharity_commitments_popup_body"></div>`;

					Components.modals()
						.type('popup')
						.className('levcharity_commitments')
						.header('Commitments')
						.body(contentHTML)
						.closeOnOutsideClick(false)
						.footer(`<button class="levcharity_button small primary_button confirm_commitment_button" data-token="${token}" data-id="${id}">${wp.i18n.__('Confirm', 'levcharity')}</button>`)
						.show();

					setTimeout(() => {
						DOM.triggerEvent(
							DOM.el('.levcharity_commitments .confirm_commitment_button'),
							'levcharity_commitment_modal_open'
						)
					}, 0)

					event.target.value = '';
				}
			}
		});
	}
}
